// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ingq","controls":"styles_controls__4bgXG","charLimit":"styles_charLimit__1ipv3","input":"styles_input__Xy9i5","send":"styles_send__EAJ94"};